import { Grid, Typography, useMediaQuery } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { DEFAULT_THEME, getTheme } from "../utils/theme";
import { IMAGES } from "../utils/constants";

const HeaderImage = (props) => {
  const { model } = props;
  const { t } = useTranslation();
  const isLg = useMediaQuery(getTheme().breakpoints.down("lg"));
  const isTablet = useMediaQuery(getTheme().breakpoints.down("tablet"));
  const styles = {
    background: {
      maxHeight: "40vw",
    },
  };

  const getModel = (obj) => {
    switch (obj) {
      case "austral":
        return <img src={IMAGES.AUSTRAL_BACKGROUND} width="100%" />;

      case "meganeEtech":
        return <img src={IMAGES.ETECH_BACKGROUND} width="100%" />;

      case "renaultDuster":
        return <img src={IMAGES.RENAULT_DUSTER_BACKGROUND} width="100%" />;

      case "renaultKangooMultix":
        return <img src={IMAGES.RENAULT_KANGOO_MULTIX_BACKGROUND} width="100%" />;

      case "renaultMaster":
        return <img src={IMAGES.RENAULT_MASTER_BACKGROUND} width="100%" />;

      case "clio6":
        return <img src={IMAGES.CLIO6_BACKGROUND} width="100%"/>;

      default:
        return null;
    }
  };

  return (
    <Grid container sx={{ ...styles.background }}>
      {/* Brand Model Image */}
      {getModel(model)}
    </Grid>
  );
};

export default HeaderImage;
